var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMoney = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 33,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "money_svg__a",
  width: 32,
  height: 33,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16 31.447c8.285 0 15-6.715 15-15 0-8.284-6.715-15-15-15s-15 6.716-15 15c0 8.285 6.715 15 15 15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m11.75 9.447 4.5 4.5 4.5-4.5m-9.75 6h10.5m-10.5 4.5h10.5m-5.25-4.5v8.25"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#money_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E85298",
  d: "M-2-1.553h36v36H-2v-36Z"
}))));
export default SvgMoney;